import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PublishIcon from "@mui/icons-material/Publish";
import { Checkbox, Chip, IconButton, Tooltip } from "@mui/material";
import UtilService from "../../../services/UtilService";
import CustomSteteChip from "../../components/CustomStateChip";
import { getPuzzleTypeById } from "../../pzl_common/PuzzleTypeConstants";

function buildColumns(showDisabledColumn = false, onPublish, publishingId, onFreeChange, savingFreeId, onRegenPreview, regeneratingId) {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "type",
            headerName: "Type",
            flex: 0.3,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                const puzzleType = getPuzzleTypeById(params.value);
                if (puzzleType) {
                    return (
                        <Chip
                            label={puzzleType.name}
                            icon={<span>{puzzleType.icon}</span>}
                            size="small"
                            variant="outlined"
                            color="primary"
                        />
                    );
                }
                return params.value || 'Unknown';
            },
        },
        {
            field: "language",
            headerName: "Language",
            flex: 0.25,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                const v = params.value || "";
                return v === "french" ? "French" : v === "english" ? "English" : v || "-";
            },
        },
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            editable: false,
            sortable: false,
            alignItems: "center",
        },
        {
            field: "free",
            headerName: "Free / Paid",
            flex: 0.28,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                const id = params.row?.id;
                const isFree = params.row?.free === true;
                const busy = savingFreeId != null && savingFreeId === id;
                return (
                    <Checkbox
                        size="small"
                        checked={isFree}
                        disabled={!id || busy || typeof onFreeChange !== "function"}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => {
                            event.stopPropagation();
                            onFreeChange(params.row, event.target.checked);
                        }}
                        slotProps={{ input: { "aria-label": isFree ? "Free, click to set paid" : "Paid, click to set free" } }}
                    />
                );
            },
        },
        {
            field: "state",
            headerName: "State",
            flex: 0.3,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                return <CustomSteteChip label={params.value} size="small" />;
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 0.32,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                const published = String(params.row?.state || "").toUpperCase() === "PUBLISHED";
                const busy = publishingId != null && publishingId === params.row?.id;
                return (
                    <>
                        <Tooltip title={regeneratingId === params.row?.id ? "Regenerating preview…" : "Regenerate preview"}>
                            <span>
                                <IconButton
                                    size="small"
                                    aria-label="Regenerate preview"
                                    disabled={Boolean(regeneratingId)}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        if (onRegenPreview) onRegenPreview(params.row);
                                    }}
                                >
                                    <ImageOutlinedIcon
                                        fontSize="small"
                                        color={regeneratingId === params.row?.id ? "disabled" : "action"}
                                    />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title={published ? "Published" : "Publish"}>
                            <span>
                                <IconButton
                                    size="small"
                                    aria-label="Publish"
                                    disabled={published || Boolean(publishingId)}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        if (onPublish) onPublish(params.row);
                                    }}
                                >
                                    <PublishIcon fontSize="small" color={published || busy ? "disabled" : "primary"} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </>
                );
            },
        },
        {
            field: "publishedAt",
            headerName: "Published At",
            flex: 0.3,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return params.value ? UtilService.formatDate(params.value) : '-';
            },
        },
        ...(showDisabledColumn
            ? [
                  {
                      field: "disabledAt",
                      headerName: "Disabled At",
                      flex: 0.3,
                      editable: false,
                      sortable: false,
                      alignItems: "center",
                      renderCell: (params) => {
                          return params.value ? UtilService.formatDate(params.value) : "-";
                      },
                  },
              ]
            : []),
    ];
}

export function getColumns(showDisabledColumn = false, onPublish, publishingId, onFreeChange, savingFreeId, onRegenPreview, regeneratingId) {
    return buildColumns(showDisabledColumn, onPublish, publishingId, onFreeChange, savingFreeId, onRegenPreview, regeneratingId);
}

